import type { SectionDef } from "./types";

export const SECTIONS: SectionDef[] = [
    { id: "wallets", title: "Wallets" },
    { id: "bridges", title: "Bridges" },
    { id: "dapps", title: "dApps" },
    { id: "oracles", title: "Oracles" },
    { id: "indexers", title: "Indexers" },
    { id: "daos", title: "DAOs" },
    { id: "explorers", title: "Explorers" },
    { id: "validators", title: "Validators" },
    { id: "core", title: "Core" },
    { id: "auditors", title: "Auditors" },
    { id: "providers", title: "Providers" },
];
